import {NavLink, Outlet} from 'react-router-dom';
import {adminNavigationItems} from '@/components/layouts/adminNavigation';

export function AdminLayout() {
    return (
        <main className="studio-main studio-admin-main" id="main-content">
            <nav aria-label="Admin navigation" className="studio-section-nav studio-admin-section-nav">
                {adminNavigationItems.map(({to, label, icon: Icon}) => <NavLink key={to} end={to === '/superadmin'} to={to}><Icon size={15} /><span>{label}</span></NavLink>)}
            </nav>
            <div className="studio-main-inner"><Outlet /></div>
        </main>
    );
}
